import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { setPostLoginRedirect } from 'src/utils/postLoginRedirect';

const AuthenticatedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    const redirectTo = `${location.pathname}${location.search || ''}`;
    setPostLoginRedirect(redirectTo);
    return <Navigate to={`/auth/login?redirect=${encodeURIComponent(redirectTo)}`} replace />;
  }

  return children;
};

export default AuthenticatedRoute;
